<template>
  <!-- <v-flex
    v-if="this.component.enable.download"
    xs6
    sm2
    md2
    class="d-inline"
  > -->
  <div v-if="this.component.enable.download" class="d-inline">
    <v-tooltip bottom>
      <v-btn
        slot="activator"
        @click.native="alterarStatusErp('xml')"
        class="bg_white"
      >
        <svg class="customIcon i_header" viewBox="0 0 18 18">
          <path d="M10.219,1.688c-4.471,0-8.094,3.623-8.094,8.094s3.623,8.094,8.094,8.094s8.094-3.623,8.094-8.094S14.689,1.688,10.219,1.688 M10.219,17.022c-3.994,0-7.242-3.247-7.242-7.241c0-3.994,3.248-7.242,7.242-7.242c3.994,0,7.241,3.248,7.241,7.242C17.46,13.775,14.213,17.022,10.219,17.022 M15.099,7.03c-0.167-0.167-0.438-0.167-0.604,0.002L9.062,12.48l-2.269-2.277c-0.166-0.167-0.437-0.167-0.603,0c-0.166,0.166-0.168,0.437-0.002,0.603l2.573,2.578c0.079,0.08,0.188,0.125,0.3,0.125s0.222-0.045,0.303-0.125l5.736-5.751C15.268,7.466,15.265,7.196,15.099,7.03"></path>
        </svg>
        <small>Validar XML</small>
      </v-btn>
      <span>{{'Inserir na fila de processamento, para enviar ao ERP'}}</span>
    </v-tooltip>
    </div>
  <!-- </v-flex> -->
</template>
<script>
export default {
  props: ["component", "arraySelect", "empresa", "table", "conta","selected"],
  data: () => ({
    menu: false,
    menuX: 0,
    menuY: 0,
    items: [
      {
        title: "XML",
        tooltip: "Baixar apenas XML das notas selecionadas",
        icon: "",
        evento: "xml"
      },
      {
        title: "PDF",
        tooltip: "Baixar apenas PDF das notas selecionadas",
        icon: "",
        evento: "pdf"
      },
      {
        title: "XML e PDF",
        tooltip: "Baixar XML e PDF das notas selecionadas",
        icon: "",
        evento: "xml-pdf"
      }
    ]
  }),
  methods: {
    setPositionMenu: function(e) {
      this.menuX = e.clientX + 15;
      this.menuY = e.clientY + 20;
      this.menu = !this.menu;
    },
    selecionarTodosItens: function() {
      this.table.selecionarTodosItens('primeiro_check')
      let selected = this.table.selecionarTodosItens('importador_xml');
      this.$emit("getSelected", selected);
    },
    alterarStatusErp: async function(evento) {
      let chaves = [];
      this.activeGlobalLoader();
      // await new Promise(r => setTimeout(r, 2000));
      let auxRmvGlobalLoader = this.desactiveGlobalLoader;
      if (this.arraySelect.length > 0) {
        let itens_ignorados = false
        await this.arraySelect.forEach(item => 
        {
          if (item) {
            if (item.statusErp != undefined){
                  if (item.statusErp != 'validada' && item.statusErp != ""){
                    itens_ignorados = true
                    return false
                  }else if(item.statusErp == ''){
                      item.statusErp = "validada"
                
                  }else if(item.statusErp == 'validada'){
                      item.statusErp = ""
                    }
                  chaves.push(item.chave);
            }else{
              item.statusErp = "validada"
              chaves.push(item.chave);
            }
            
          }
        });
        // this.table.selecionarTodosItens('importador_xml')
        if (itens_ignorados){
          this.table.snackAlert();
          this.table.snack.text = "Existe itens selecionados que já foram integrados, e não foi possivel alterar o status";
          this.table.snack.show = true;
        }
        await this.setStatusErp(chaves);
      } else {
        this.table.snackAlert();
        this.table.snack.text = "Necessário escolher ao menos uma nota";
        this.table.snack.show = true;
      }
      this.selecionarTodosItens()
      auxRmvGlobalLoader();
    },
    setStatusErp: function(chaves) {
      //debugger;
      let url = this.$http.options.root;
      switch (this.component.name) {
        case "CTE":
          url += "ctes/download/multi";
          break;
        case "NFeRecebidas":
          url += "nfe/statusErp/mult";
          break;
        case "NFSE":
          url += "nfses/download/multi";
          break;
        default:
          throw new Error("Não foi possísvel setar url para alterar statusErp");
      }
      // WARNING: For POST requests, body is set to null by browsers.
      var data = JSON.stringify({
        "id_empresa": this.empresa._id,
        "chaves": chaves,
        "cnpj": this.empresa.cnpj
      });

      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");



    let requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: data,
      redirect: 'follow'
    };

    return fetch(url, requestOptions)
      

      // var xhr = new XMLHttpRequest();
      // xhr.withCredentials = true;

      // xhr.addEventListener("readystatechange", function() {
      // if(this.readyState === 4) {
      //   console.log(this.responseText);
      // }
      // });

      // xhr.open("POST", url, true);

      // xhr.setRequestHeader("Content-Type", "application/json");

      // xhr.send(data);
     

      // APÓS SEPARAÇÃO EM MICROSERVIÇOS DEVERÁ FICAR ASSIM
      // APÓS SEPARAÇÃO EM MICROSERVIÇOS DEVERÁ FICAR ASSIM
      // APÓS SEPARAÇÃO EM MICROSERVIÇOS DEVERÁ FICAR ASSIM
      // let url = this.$http.options.root;
      // switch (this.component.name) {
      //   case "CTE":
      //     url += "ctes/download/multi";
      //     break;
      //   case "NFeRecebidas":
      //     url += "nfes/download/multi";
      //     break;
      //   case "NFSE":
      //     url += "nfses/download/multi";
      //     break;
      //   default:
      //     throw new Error("Não foi possísvel setar url para buscar zip");
      // }
      // url = 'http://localhost:3050/util/gerarZip'
      // var xhr = new XMLHttpRequest();
      // xhr.open("POST", url, true);
      // xhr.setRequestHeader("Content-type", "application/json");
      // xhr.setRequestHeader("Authorization", Vue.http.headers.common['Authorization']);
      // this.activeGlobalLoader();
      // var fileName = `${this.component.abrev}-${notas.acao}.zip`;
      // let auxRmvGlobalLoader = this.desactiveGlobalLoader;
      // xhr.onreadystatechange = function() {
      //   if (xhr.readyState == 4 && xhr.status == 200) {
      //     var blob = new Blob([new Uint8Array(xhr.response.zip.data)], {
      //       type: "application/zip"
      //     });
      //     if (navigator.msSaveOrOpenBlob) {
      //       navigator.msSaveOrOpenBlob(blob, fileName);
      //     } else {
      //       var a = document.createElement("a");
      //       document.body.appendChild(a);
      //       a.style = "display:none";
      //       var url = window.URL.createObjectURL(blob);
      //       a.href = url;
      //       a.download = fileName;
      //       a.click();
      //       window.URL.revokeObjectURL(url);
      //       a.remove();
      //       auxRmvGlobalLoader();
      //     }
      //   } else {
      //     auxRmvGlobalLoader();
      //   }
      // };

      // xhr.responseType = "json";
      // notas['tipo_doc'] = this.component.name.toLowerCase();
      // xhr.send(JSON.stringify(notas));
    },
    activeGlobalLoader: function() {
      const appDom = document.querySelector("#app");
      const icon = document.querySelector("#app main +i.c_custom-loader");
      const body = document.querySelector("body");
      const html = document.querySelector("html");
      body.classList.add("loading_global");
      html.classList.add("loading_global");

      appDom.classList.add("loading_global");
      icon.classList.add("loading_global");
    },
    desactiveGlobalLoader: function() {
      const appDom = document.querySelector("#app");
      const icon = document.querySelector("#app main +i.c_custom-loader");
      const body = document.querySelector("body");
      const html = document.querySelector("html");
      body.classList.remove("loading_global");
      html.classList.remove("loading_global");
      appDom.classList.remove("loading_global");
      icon.classList.remove("loading_global");
    }
  }
};
</script>

<style>
</style>





// WEBPACK FOOTER //
// src/components/dataTable/commonTable/actionsHeader/btnImportadorXml/BtnImportadorXml.vue